import {
  styled, rem
} from 'config/stitches.config'

export const StyledCarousel = styled('div', {
  width: '100%',

  'button': { all: 'unset' },

  '.carousel__slider-tray--horizontal': { display: 'flex', },

  '.carousel__slider-tray-wrapper': { overflow: 'hidden', },

  '.carousel__dot': {
    width: '8px',
    height: '8px',
    backgroundColor: '#DADADA',
    borderRadius: '2px',
  },

  '.carousel__dot--selected': { backgroundColor: '#26376D', },

  '.move-button': {
    backgroundColor: 'white',
    padding: '0.75rem 0.75rem',
    display: 'flex',
    borderRadius: '8px',
    cursor: 'pointer',
    boxShadow: '0 2px 8px rgba(0, 0, 0, 0.05)',
  },

  '.carousel': {
    gap: rem(24),
    flexDirection: 'column',
    display: 'flex',
  },
})

export const StyledCarouselNavigation = styled('div', {
  gap: rem(16),
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
})

export const StyledCarouselSlide = styled('div', {
  overflow: 'hidden',
  height: '50vh',
  width: '100%',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginX: 'auto',
  paddingX: rem(8),

  '@media (min-aspect-ratio: 16/9)': { height: '50vh' },
  '@media (max-aspect-ratio: 16/9)': { width: '100%' },

  'img': {
    marginX: 'auto',
    // width: '100%',
    // objectFit: 'contain',
    clipPath: 'inset(0 round 20px)',
  },

  variants: {
    fit: {
      cover: {
        height: 'auto',
        aspectRatio: '1 / 1',
        'img': {
          height: '100%', objectFit: 'cover'
        }
      }
    }
  }
})
